import React, { forwardRef, useState } from "react";
import { Row, Col } from "antd";
import Surface from "../../../components/layouts/Surface";
import { FormattedMessage } from "react-intl";
import FormHeader from "../../../components/forms/FormHeader";
import { EmployeesSelect } from "../../../components/forms/AutoCompleteFormItem";
import Date from "../../../components/tables/Date";
import { ReactComponent as EmployeeImg } from "../../../assets/no-employees.svg";
import DynamicItem from "../../../components/forms/DynamicItem";
import EmployeeLink from "../../../components/tables/EmployeeLink";
import { useSelector } from "react-redux";
import isEqual from "lodash.isequal";

const Corporation = forwardRef((props, ref) => {
  const { activePatient, smallSpace } = props;
  const [employeesList, setEmployeesList] = useState([]);
  const [activeItem, setActiveItem] = useState(null);

  const changedItems = useSelector(
    (state) => state.patientDetails.changedItems.changed
  );

  const changedValues = useSelector(
    (state) => state.patientDetails.changedItems.values
  );

  const onFinish = (tableData, newRecord, activeKey, onChange) => {
    const employee = employeesList.filter(
      (i) => i.id === newRecord.employee_id
    )[0];
    const filtered = tableData.filter((i) => i.key !== activeKey);
    onChange([...filtered, { ...newRecord, employee }]);
  };

  const filterItems = (data) => {
    const isEqualArray = isEqual(employeesList, data);
    if (!isEqualArray) {
      setEmployeesList(data);
    }
    let employees = [];
    if (changedItems.includes("foreign_worker_associations")) {
      employees = changedValues.foreign_worker_associations;
    } else {
      employees = activePatient.foreign_worker_associations;
    }
    const ids = employees.map((s) => s.employee_id);
    const index = activeItem && ids.indexOf(activeItem.employee_id);
    if (index > -1) {
      ids.splice(index, 1);
    }
    const filtered = data.filter((i) => !ids.includes(i.id));
    return filtered;
  };

  const setFormActiveItem = (item) => {
    setActiveItem(item);
  };

  const foreignFilter = {
    $and: [
      { employee_type_id: 2 },
      { status: 1 },
      {
        foreign_tourist_with_license: {
          $neq: true,
        },
      },
    ],
  };
  return (
    <div style={{ display: "flex", flexDirection: "column" }} ref={ref}>
      <Surface smallSpace={smallSpace}>
        <FormHeader
          title={<FormattedMessage id="app.patients.corporation" />}
        />
        <Row>
          <Col span={24}>
            <DynamicItem
              resource={"patients"}
              action={"editor"}
              emptyImg={<EmployeeImg />}
              name="foreign_worker_associations"
              category="patient"
              addText={
                <FormattedMessage id="app.patients.addAssociatedEmployee" />
              }
              onFinish={onFinish}
              setFormActiveItem={setFormActiveItem}
              tableItems={[
                {
                  title: "employee_id",
                  formRender: (
                    <EmployeesSelect
                      name="foreign_worker_associations.employee_id"
                      category="patient"
                      waitForFetch={!activePatient}
                      extraParams={{
                        filter: foreignFilter,
                        scopePrefix: `branches/${activePatient.branch}/`,
                      }}
                      filterItems={filterItems}
                      items={activeItem ? [{ ...activeItem.employee }] : []}
                    />
                  ),
                  render: EmployeeLink,
                  subRecord: "employee",
                  columnProps: {
                    branch: activePatient.branch,
                  },
                },
                {
                  title: "employment_license_number",
                  type: "input",
                  onlyDigits: true,
                  required: true,
                },
                {
                  title: "employment_license_expiration",
                  type: "date",
                  required: true,
                  columnProps: { format: "L" },
                  render: Date,
                },
              ]}
            />
          </Col>
        </Row>
      </Surface>
    </div>
  );
});

export default Corporation;
